import React, { memo, useMemo } from 'react';
import { RoomSelect } from 'global/components/room-select';
import { Column, Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { size } from 'global/lib/lodash';
import { FlexGridRow, MarginLeftZebraList } from 'global/components/flex-grid-list';
import {
  AssignmentCheckpointRow,
  isCheckpointTaggedForRoom,
  uniformHeaderRoomsAndBulkCompare,
} from '../assignment-list/AssignmentRows';
import { ChecklistRoot } from './style';

const MODAL_TITLE_FIX_MARGINS = { marginLeft: 5, pointerEvents: 'none' };

function RoomAssignmentChecklistInner(props) {
  const {
    supersets,
    checklist,
    updateChecks,
    copiedRooms,
    onCopy,
    isMobileXS,
    rooms,
    rowClassName,
    previewRealm,
    previewShowOnlyChecked = false,
  } = props;
  const { checkpoints } = checklist;
  const interaction = previewRealm ? 'previewCheckbox' : 'roomSelect';

  const checkpointsToRender =
    previewRealm && previewShowOnlyChecked
      ? checkpoints.filter((cp) => isCheckpointTaggedForRoom(cp, previewRealm))
      : checkpoints;

  const [headerRooms, bulkCompareRooms] = useMemo(
    () => uniformHeaderRoomsAndBulkCompare(checklist?.checkpoints, (cp) => cp.rooms),
    [checklist]
  );

  const getSupersetName = () => {
    if (!size(supersets)) {
      return '';
    }
    const sup = supersets.find((s) => String(s.id) === String(checklist.supersetId));
    if (sup) {
      return `${sup.name}: `;
    }
    return '';
  };

  if (previewRealm && previewShowOnlyChecked && !size(checkpointsToRender)) {
    return null;
  }

  const title = (style = { minWidth: 200 }) => (
    <Row style={style}>
      <Text bold type="title_medium">{`${getSupersetName()}${checklist.name} (${size(checkpointsToRender)}${previewShowOnlyChecked && size(checkpointsToRender) !== size(checkpoints) ? ` of ${size(checkpoints)}` : ''})`}</Text>
    </Row>
  );

  const CONT = isMobileXS ? Column : Row;

  return (
    <ChecklistRoot>
      <CONT>
        {title()}
        {!previewRealm && (
          <div style={{ marginLeft: 'auto' }}>
            <RoomSelect
              value={headerRooms}
              rooms={rooms}
              onCopy={onCopy}
              onPaste={copiedRooms ? () => copiedRooms : undefined}
              onChange={(s, areEqual) => updateChecks(checklist, s, null, areEqual)}
              type="inlineModal"
              modalTitle={title({ ...MODAL_TITLE_FIX_MARGINS, marginLeft: 30, marginTop: 4 })}
            />
          </div>
        )}
      </CONT>
      <MarginLeftZebraList>
        {checkpointsToRender.map((cp, _i) => (
          <FlexGridRow fullBleed key={cp.id ?? _i}>
            <AssignmentCheckpointRow
              checkpoint={cp}
              checklist={checklist}
              rooms={rooms}
              updateChecks={updateChecks}
              onCopy={onCopy}
              copiedRooms={copiedRooms}
              isMobileXS={isMobileXS}
              fixMargins={MODAL_TITLE_FIX_MARGINS}
              rowClassName={rowClassName}
              interaction={interaction}
              previewRealm={previewRealm}
              bulkCompareRooms={previewRealm ? null : bulkCompareRooms}
            />
          </FlexGridRow>
        ))}
      </MarginLeftZebraList>
    </ChecklistRoot>
  );
}

export const RoomAssignmentChecklist = memo(RoomAssignmentChecklistInner);
